import { getListProjectBenchmarksQueryOptions } from '@amarantos/api-client'
import { createFileRoute } from '@tanstack/react-router'
import { RouteErrorFallback } from '@/components/route-error-fallback'
import { benchmarksSearchSchema, ProjectBenchmarksPanel } from '@/features/benchmarks'
import { listAllProjectAssetsParams } from '@/features/projects/utils/project-asset-list'

// The project's Repery tab: the benchmarks foremen level against to establish their daily baseline.
// Elevations are maintained here in the panel and never measured in the app (ADR-0009). Deleting
// withdraws a benchmark from the catalog without erasing it (ADR-0028) — a baseline's reference to
// it is that baseline's provenance, so the record is retained (`CONTEXT.md` → *Benchmark*).
export const Route = createFileRoute('/_authenticated/projects/$projectId/benchmarks')({
	validateSearch: benchmarksSearchSchema,
	loader: ({ context: { queryClient }, params: { projectId } }) => {
		queryClient.ensureQueryData(getListProjectBenchmarksQueryOptions(projectId, listAllProjectAssetsParams))
	},
	errorComponent: ({ error, reset }) => (
		<RouteErrorFallback error={error} reset={reset} fallbackMessageKey='error.load_benchmarks' />
	),
	component: ProjectBenchmarksRoute,
})

function ProjectBenchmarksRoute() {
	const { projectId } = Route.useParams()
	const search = Route.useSearch()
	const navigate = Route.useNavigate()

	// Dialog state lives in the URL, so the create/edit dialogs are deep-linkable.
	const closeDialog = () => {
		navigate({ search: (previous) => ({ ...previous, dialog: undefined, benchmarkId: undefined }) })
	}

	return (
		<ProjectBenchmarksPanel
			projectId={projectId}
			dialog={search.dialog}
			selectedId={search.benchmarkId}
			onCreate={() => navigate({ search: (previous) => ({ ...previous, dialog: 'create' as const }) })}
			onEdit={(benchmark) =>
				navigate({ search: (previous) => ({ ...previous, benchmarkId: benchmark.id, dialog: 'edit' as const }) })
			}
			onClose={closeDialog}
		/>
	)
}
